import React, { Fragment } from 'react'
import { host, hostSocket } from '../../../configuraciones';
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import { Task, UploadFile } from '@mui/icons-material';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { renderSolicitud, renderTipoSolicitud, colorByStatusSolicitud } from '../../UsuarioInspectorEnCampo/InspectorUtils/InspectorUtils'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import SeleccionarDictamenComponent from './GenerarDictamenes/SeleccionarDictamenComponent';
import { obtenerFC_09SolicitudDetalle } from '../../../redux/FC_09Ducks';


function SolicitudComponent(props) {

    const dispatch = useDispatch();

    const [openTipoDictamen, setOpenTipoDictamen] = React.useState(false);

    const handleOpenTipoDictamen = (l) => {
        setOpenTipoDictamen(true)
    }

    const handleCloseTipoDictamen = () => {
        setOpenTipoDictamen(false)
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 320,
        height: 430,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const modalSeleccionarTipoDictamen = () => {
        return (
            <Fragment>
                {
                    <Modal
                        open={openTipoDictamen}
                        onClose={handleCloseTipoDictamen}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style}>
                            <div style={{ textAlign: 'center' }}>
                                <h4>Tipo de Dictamen</h4>
                            </div>
                            {
                                props.tipo == 9 ?
                                    <Fragment>
                                        <SeleccionarDictamenComponent tipo={props.tipo} solicitud={props.solicitud}></SeleccionarDictamenComponent>
                                    </Fragment>
                                    :
                                    props.tipo == 30 ?
                                        <Fragment>
                                            <SeleccionarDictamenComponent tipo={props.tipo} solicitud={props.solicitud}></SeleccionarDictamenComponent>
                                        </Fragment>
                                        :
                                        <Fragment></Fragment>
                            }
                        </Box>

                    </Modal>
                }
            </Fragment>

        )
    }

    return (
        <Fragment >

            <div className={renderSolicitud(1)}>
                <div className='row card-header text-center' style={{ backgroundColor: colorByStatusSolicitud(5) }}>
                    <div className='col-4'>
                        <p style={{ fontSize: '20px', fontWeight: 'bold' }}> Folio: {props.solicitud.folio} </p>
                    </div>
                    <div className='col-4'>
                        <h4><strong>{renderTipoSolicitud(1)}</strong></h4>
                    </div>
                    {/* <div className='col-4'>
                        Estatus de la Solicitud:
                        <br />


                    </div> */}
                </div>
                <div className='row'>
                    <div className='col-4'>
                        <p style={{ fontSize: '15px', fontWeight: 'bold', display: 'inline' }}>
                            Estimada para: <strong style={{ fontSize: '15px', display: 'inline' }}>{props.solicitud.fechasolicitud}</strong></p><br />
                        <br />
                        <div className='row'>
                            <div className='col-4'>
                                <button className='badge btn-primary' ><DocumentScannerIcon />Ver Solicitud</button>
                            </div>
                            {/* <div className='col-4'>
                                <button className='badge btn-primary'><DocumentScannerIcon />Ver Escrito De Comision</button>
                            </div> */}
                        </div>
                        <div className="row">
                            {/* <div className='col-4'>
                                <button className='badge btn-success' ><AssignmentIcon />Ver Informe</button>
                            </div>

                            <div className='col-4'>
                                <button className='badge btn-success'  ><UploadFile />Subir Informe</button>
                            </div> */}

                            <div className='col-4'>
                                <button className='badge btn-primary' ><DocumentScannerIcon />Ver Dictámen</button>
                            </div>

                        </div>


                    </div>
                    <div className='col-4 text-center' style={{ display: 'inline' }}>
                        <p style={{ fontSize: '15px', fontWeight: 'bold', display: 'inline' }}> Atendido por:</p><br />
                        <p style={{ fontSize: '15px', fontWeight: 'bold', textDecoration: 'underline', display: 'inline' }}>{props.solicitud.revisor}</p><br />
                        <hr />
                        <p style={{ fontSize: '15px', fontWeight: 'bold', display: 'inline' }}> Responsable de la Instalacion:</p><br />
                        <p style={{ fontSize: '15px', fontWeight: 'bold', textDecoration: 'underline', display: 'inline' }}>{props.solicitud.resposableinstalaciones}</p><br />
                    </div>
                    <div className='col-4 text-center' >
                        <p style={{ fontSize: '20px' }}>( {props.solicitud.numerocliente}) : {props.solicitud.nombrecliente} <br /></p>
                        <strong style={{ width: '100%', textAlign: 'justify' }}>
                            {/* Productor de Maguey */}
                        </strong>
                        <br /><br />
                        {/* <div className='col-4'>
                            <button className='badge btn-danger' ><DocumentScannerIcon />Corregir Dictamen</button>
                        </div> */}

                        <div className='row'>
                            {/* <div className='col-4'>

                                <button className='badge btn-primary'><AccessibilityIcon />Reasignar</button>

                                <button className='badge btn-primary'><AccessibilityIcon />Asignar</button>

                                <br />

                                {
                                    //<button onClick={handleOpenModalReagendar} style={{ marginBottom: '3%', width: '70%' }} className='btn btn-success'><CalendarMonthIcon />Reagendar Visita</button>
                                }
                            </div> */}
                            <div className='col-4'>
                                <button className='badge btn-primary' onClick={() => handleOpenTipoDictamen()}><DocumentScannerIcon />Generar Dictámen</button>
                            </div>

                        </div>
                        <br></br>
                    </div>

                </div>
            </div>
            {modalSeleccionarTipoDictamen()}
        </Fragment>

    );
}

export default withRouter(SolicitudComponent)